import { useMutation, useQueryClient } from 'react-query';
import { useService } from 'shared/providers';
import { ContractDocument } from 'shared/types';

export function useCreateDraftContract() {
  const queryClient = useQueryClient();
  const { draftContractService } = useService();
  const mutation = useMutation<ContractDocument, Error, ContractDocument>(
    request => draftContractService.createNewDraftContract(request),
    {
      onSuccess: data => {
        queryClient.invalidateQueries('draft-contract');
      },
    }
  );

  return mutation;
}
